import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect } from 'react';
import { BsFacebook} from 'react-icons/bs';
import { FcGoogle } from 'react-icons/fc';
import { GrInstagram } from "react-icons/gr";
import { Link, useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import { URL } from './env';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(5),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
};

export default function CustomizedDialogs() {
  const [open, setOpen] = React.useState(false);
  const [dbms, setDbms] = React.useState();
  const [login, setLogin] = React.useState();
  const [email, setEmail] = React.useState('');
  const [pass, setPass] = React.useState('');
  let naviget = useNavigate();


  let fetchData = () => {
    fetch(URL+'get_data.php')
      .then((res) => res.json())
      .then((data) => {
        if(data[0]){
          setDbms(data[0].uname || data)
        }
      });
  };

  let loginData = () => {
    fetch(URL+'logindata.php')
      .then((res) => res.json())
      .then((data) => setLogin(data));
  };
  

  useEffect(() => {
    setTimeout(() => {
      setOpen(true);
    }, 3000);
    fetchData();
    loginData();
  }, []);

  let loginClick = (e) => {
    e.preventDefault();
    let fildata = login.filter((v) => v.email === email && v.password === pass);

    if (email === '' || pass === '') {
      swal({
        text: 'Please Fill Values',
        icon: 'warning',
      });
    } else if (!fildata[0]) {
      swal({
        text: 'Fill Data is Incorrect',
        icon: 'warning',
      });
    } else if (fildata[0]) {
      naviget('/');
      setOpen(false);
    }

    localStorage.setItem('Email', fildata[0].email);
    localStorage.setItem('password', fildata[0].password);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {!localStorage.getItem('Email') && !localStorage.getItem('Name') ? (
        <div>
          <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
          >
            <BootstrapDialogTitle id="customized-dialog-title">
              Login Form
            </BootstrapDialogTitle>
            <DialogContent dividers>
              <form onSubmit={loginClick}>
                <div className="form-outline">
                  <label className="form-label" htmlFor="form2Example1">
                    Email address
                  </label>
                  <br></br>
                  <input
                    className="form-control form-control-lg"
                    type="text"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                  />
                </div>

                <div className="form-outline mb-2">
                  <label className="form-label" htmlFor="form2Example2">
                    Password
                  </label>
                  <input
                    className="form-control form-control-lg"
                    type="text"
                    onChange={(e) => setPass(e.target.value)}
                    value={pass}
                  />
                </div>

                <div className="text-center">
                  <button
                    type="submit"
                    className="btn btn-primary btn-block mb-4 float-center"
                  >
                    Login
                  </button>
                </div>

                <div className="text-center">
                  <p>
                    Not a member? <Link to="/Signin">Register</Link>
                  </p>
                  <p>or sign up with:</p>
                  <button
                    type="button"
                    className="btn btn-link btn-floating mx-1"
                  >
                    <a target='_blank' href='https://accounts.google.com/signin/v2/identifier?elo=1&flowName=GlifWebSignIn&flowEntry=ServiceLogin' rel="noreferrer"><FcGoogle size="30px"/></a>
                  </button>

                  <button
                    type="button"
                    className="btn btn-link btn-floating mx-1"
                  >
                    <a target='_blank' href='https://www.facebook.com/' rel="noreferrer"><BsFacebook size="30px" /></a>
                  </button>

                  <button
                    type="button"
                    className="btn btn-link btn-floating mx-1"
                  >
                    <a target='_blank' href="https://www.instagram.com/accounts/login/?hl=en" rel="noreferrer"><GrInstagram size="28px" /></a>
                  </button>
                </div>
              </form>
            </DialogContent>
          </BootstrapDialog>
        </div>
      ) : (
        ''
      )}
    </>
  );
}
